<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YSXna9/tc-custom/9781507301012.jpg?1731796626959" alt="This image is the cover for the book Do Not Open the Box"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Do Not Open the Box
      </h1>
      <p class="bookDescription body article font2">
        <p>Benny spots a big cardboard box with a note taped to it saying, "Do Not Open." His imagination runs wild, and it's almost too much for a curious boy to bear. He thinks about all of the things, good and bad, that could be inside that box. A birthday robot? A wolverine? An entrance to another world? What should he do? This endearingly illustrated tale of a classic childhood dilemma has a surprise ending and offers a peek into a young boy's mind as he weighs tantalizing possibilities against the risks of breaking the rules.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy Young
      </h2>
      
      <p class="authorDescription body article">Timothy Young has had a long career doing all kinds of interesting and fun stuff. He's been an animator, puppet maker, toy designer, sculptor, art director and graphic designer. His career highlights include being a head model-maker for Pee-Wee's Playhouse, designing and building Muppets for Jim Henson Productions and sculpting the first Simpsons toys. Tim is the author/illustrator of 8 picture books including Do Not Open The Box, The Angry Little Puffin and the highly acclaimed I Hate Picture Books!. His latest books are I'm Going To Outer Space!, and the how-to-draw book, Creatures and Characters: Drawing Amazing Monsters, Aliens and Other Weird Things. He has also illustrated for other authors.  His favorite part of being an author is traveling to schools and talking to kids about his books. If you'd like to find out how to have him visit your school, his website is easy to find by searching his name.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing, Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ca533a8e